import React, { forwardRef, Fragment, useState } from 'react';
import styled from '@emotion/styled';
import Link from '@polestar/component-warehouse-react/components/link/Link';
import Icon from '@polestar/component-warehouse-react/components/icon/Icon';
import * as Icons from '@polestar/component-warehouse-react/tokens/icons/Icons';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
import useResizeCallback from '@polestar/component-warehouse-react/hooks/useResizeCallback';
import { css } from '@emotion/react';
import useMediaQuery from '@polestar/component-warehouse-react/hooks/useMediaQuery';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
import { TextAnchorButton, } from '@polestar/component-warehouse-react/components/button/Button';
import Alignments, { MainAxisAlignments, } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
const Breadcrumbs = forwardRef(({ links, ...props }, ref) => {
    const [fitsWidth, setFitsWidth] = useState(true);
    const { name } = useMediaQuery();
    const isMobile = name === DeviceTypes.mobile;
    const internalRef = useResizeCallback((node) => {
        setFitsWidth(node.clientWidth >= node.scrollWidth);
    }, []);
    const combinedRef = useCombinedRef(internalRef, ref);
    // Don't render anything when less then 2 items are provided
    if (links.length < 2) {
        return null;
    }
    const { label: previousPageLabel, ...previousPageProps } = links[links.length - 2];
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { forceMobileVariant: !fitsWidth && !isMobile, "aria-label": "breadcrumbs", ...props, ref: combinedRef }, links.map(({ label, ...linkProps }, index) => {
            const isLast = index === links.length - 1;
            if (isLast) {
                return (React.createElement(Paragraph, { key: index, "aria-current": "location", ...linkProps }, label));
            }
            return (React.createElement(Fragment, { key: index },
                React.createElement(Link, { hideUnderline: true, ...linkProps }, label),
                React.createElement(StyledIcon, { icon: Icons.chevronRight })));
        })),
        React.createElement(BackButton, { ...previousPageProps, forceMobileVariant: !fitsWidth && !isMobile, icon: Icons.arrowLeft, iconPosition: Alignments.left, ...aria({ hidden: fitsWidth && !isMobile }) }, previousPageLabel)));
});
Breadcrumbs.displayName = 'Breadcrumbs';
export default Breadcrumbs;
const Container = styled.nav(({ forceMobileVariant }) => css(css `
      display: none;
      align-items: center;
      justify-content: ${MainAxisAlignments.start};
      flex-wrap: nowrap;
      white-space: nowrap;
      max-width: 100%;

      ${MediaQueries.tablet} {
        display: flex;
      }
    `, forceMobileVariant &&
    css `
        visibility: hidden;
        pointer-events: none;
        height: 0;
        overflow: hidden;
      `));
Container.displayName = `Container`;
const StyledIcon = styled(Icon) `
  margin: 0 ${Spacings.xxSmall};
  opacity: ${Opacities.medium};
`;
const BackButton = styled(TextAnchorButton)(({ forceMobileVariant }) => css(css `
        display: inline-block;

        ${MediaQueries.tablet} {
          display: none;
        }
      `, forceMobileVariant &&
    css `
          display: inline-block !important;
        `));
